<template>
  <skud-visit-list />
</template>

<script>
import SkudVisitList from '@/views/skud/components/SkudVisitList.vue'

export default {
  name: 'SkudVisitListPage',
  components: { SkudVisitList }
}
</script>
